import { render, staticRenderFns } from "./PersonGroupPage.vue?vue&type=template&id=08cba22c&"
import script from "./PersonGroupPage.vue?vue&type=script&lang=js&"
export * from "./PersonGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonGroupPage.vue?vue&type=style&index=0&id=08cba22c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports